var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKanban(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99675 3.99667H14.0009C14.5534 3.99667 15.0013 4.44458 15.0013 4.99709V20.0033H3.99675C3.44424 20.0033 2.99634 19.5554 2.99634 19.0029V4.99709C2.99634 4.44458 3.44424 3.99667 3.99675 3.99667Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0015 7.99832H20.0035C20.5561 7.99832 21.004 8.44622 21.004 8.99874V19.0029C21.004 19.5554 20.5561 20.0033 20.0035 20.0033H15.0015V7.99832Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99801 7.87326C6.92895 7.87326 6.87296 7.92925 6.87296 7.99832C6.87296 8.06738 6.92895 8.12337 6.99801 8.12337C7.06708 8.12337 7.12306 8.06738 7.12306 7.99832C7.12306 7.92925 7.06708 7.87326 6.99801 7.87326",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 7.87326C10.9307 7.87326 10.8747 7.92925 10.8747 7.99832C10.8747 8.06738 10.9307 8.12337 10.9997 8.12337C11.0688 8.12337 11.1248 8.06738 11.1248 7.99832C11.1248 7.92925 11.0688 7.87326 10.9997 7.87326",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99801 11.8749C6.92895 11.8749 6.87296 11.9309 6.87296 12C6.87296 12.0691 6.92895 12.125 6.99801 12.125C7.06708 12.125 7.12306 12.0691 7.12306 12C7.12306 11.9309 7.06708 11.8749 6.99801 11.8749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 11.8749C10.9307 11.8749 10.8747 11.9309 10.8747 12C10.8747 12.0691 10.9307 12.125 10.9997 12.125C11.0688 12.125 11.1248 12.0691 11.1248 12C11.1248 11.9309 11.0688 11.8749 10.9997 11.8749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99801 15.8766C6.92895 15.8766 6.87296 15.9326 6.87296 16.0017C6.87296 16.0707 6.92895 16.1267 6.99801 16.1267C7.06708 16.1267 7.12306 16.0707 7.12306 16.0017C7.12306 15.9326 7.06708 15.8766 6.99801 15.8766",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 15.8766C10.9307 15.8766 10.8747 15.9326 10.8747 16.0017C10.8747 16.0707 10.9307 16.1267 10.9997 16.1267C11.0688 16.1267 11.1248 16.0707 11.1248 16.0017C11.1248 15.9326 11.0688 15.8766 10.9997 15.8766",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0026 11.8749C17.9336 11.8749 17.8776 11.9309 17.8776 12C17.8776 12.0691 17.9336 12.125 18.0026 12.125C18.0717 12.125 18.1277 12.0691 18.1277 12C18.1277 11.9309 18.0717 11.8749 18.0026 11.8749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0026 15.8766C17.9336 15.8766 17.8776 15.9326 17.8776 16.0017C17.8776 16.0707 17.9336 16.1267 18.0026 16.1267C18.0717 16.1267 18.1277 16.0707 18.1277 16.0017C18.1277 15.9326 18.0717 15.8766 18.0026 15.8766",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanban);
export default __webpack_public_path__ + "static/media/Kanban.bc073fc2.svg";
export { ForwardRef as ReactComponent };